package com.patronat.top.library.media.domain.command


import com.patronat.top.dto.ImageType
import com.patronat.top.library.media.data.FileSource

data class UploadImageCommand(
    val file: FileSource,
    val type: ImageType,
    val mimeType: String = "image/jpeg",
    val onProgress: ((Float) -> Unit)? = null
)